import { styled, Pill, Box } from '@/theme/index';

type ImageBoxProps = {
  src: string;
};

export const ImagePill = styled(Pill)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  borderRadius: '4px',
  backgroundColor: theme.palette.grey[200],
}));

export const CarouselCard = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '270px',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderBottomLeftRadius: theme.spacing(0.5),
  borderBottomRightRadius: theme.spacing(0.5),
  paddingBottom: theme.spacing(2),
}));

export const ImageBox = styled(Box)<ImageBoxProps>(({ theme, src }) => ({
  width: '100%',
  height: '200px',
  background: `url(${src})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    height: '100px',
  },
}));
